import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class SubmissionsService {

  constructor(
    private http: Http
  ) { }

  getAll() {
    return this.http
      .get(`${environment.apiUrl}/admin/renders`)
      .map(this.extractData)
      .map((rawRenders: {global_fields: any, renders: any}) => rawRenders.renders)
      .map(renders => {
        return renders.map(render => {
          if (render.submission) {
            render.submission.outgoing_engine_data = JSON.parse(render.submission.outgoing_engine_data);
          }
          render.output = JSON.parse(render.output);

          return render;
        }).filter(render => {
          return !!render.submission;
        });
      });
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/submissions.service.ts